import React, { useState } from "react";
import axios from "axios";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import { API_BASE_URL } from "../../super-admin/Config/Config";

const SigninTwo = () => {
  const route = all_routes;
  const navigate = useNavigate();

  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const [validationErrors, setValidationErrors] = useState({
    username: "",
    password: "",
  });

  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible((prevState) => !prevState);
  };

  const validateForm = () => {
    const errors = { username: "", password: "" };
    let isValid = true;

    if (!username.trim()) {
      errors.username = "Username is required";
      isValid = false;
    } else if (username.length < 4) {
      errors.username = "Username must be at least 4 characters";
      isValid = false;
    }

    if (!password.trim()) {
      errors.password = "Password is required";
      isValid = false;
    } else if (password.length < 4) {
      errors.password = "Password must be at least 4 characters";
      isValid = false;
    }

    setValidationErrors(errors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!validateForm()) return;

    try {
      setIsLoading(true);

      const response = await axios.post(`${API_BASE_URL}api/admin/userlogin`, {
        LoginName: username,
        PasswordHash: password,
      });

      const data = response?.data;
      console.log(data,"dsvcxjkhasdhcvhasdbc")

      if (!data) {
        setError("Invalid response");
        return;
      }

      if (data.status === false) {
        setError(data.Message || "Invalid username or password");
        return;
      }

      sessionStorage.setItem("isAuthorizedHealthCheck", "true");
      sessionStorage.setItem("HealthCheckuser", JSON.stringify(data.ResultData));

      navigate(route.superadmindashboard);
    } catch (err) {
      console.error("Login error:", err);
      setError("Invalid username or password");
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <>
      <div className="main-wrapper">
        <div className="account-content">
          <div className="row login-wrapper m-0">
            <div className="col-lg-6 p-0">
              <div className="login-content">
                <form onSubmit={handleSubmit}>
                  <div className="login-userset">
                    <div className="login-logo logo-normal">
                      <ImageWithBasePath src="assets/img/logo.png" alt="img" />
                    </div>
                    <Link
                      to={route.dashboard}
                      className="login-logo logo-white"
                    >
                      <ImageWithBasePath
                        src="assets/img/logo-white.png"
                        alt="Img"
                      />
                    </Link>
                    <div className="login-userheading">
                      <h3>Sign In</h3>
                      <h4>
                        Access the Health Check using your Username and
                        Password.
                      </h4>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Username</label>
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control border-end-0"
                          value={username}
                          onChange={(e) => {
                            setUsername(e.target.value);
                            setValidationErrors({
                              ...validationErrors,
                              username: "",
                            });
                          }}
                        />
                        <span className="input-group-text border-start-0">
                          <i className="ti ti-mail" />
                        </span>
                      </div>
                      {validationErrors.username && (
                        <span className="text-danger small">
                          {validationErrors.username}
                        </span>
                      )}
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Password</label>
                      <div className="pass-group">
                        <input
                          type={isPasswordVisible ? "text" : "password"}
                          className="pass-input form-control"
                          value={password}
                          onChange={(e) => {
                            setPassword(e.target.value);
                            setValidationErrors({
                              ...validationErrors,
                              password: "",
                            });
                          }}
                        />
                        <span
                          className={`ti toggle-password ${
                            isPasswordVisible ? "ti-eye" : "ti-eye-off"
                          }`}
                          onClick={togglePasswordVisibility}
                        ></span>
                      </div>
                      {validationErrors.password && (
                        <span className="text-danger small">
                          {validationErrors.password}
                        </span>
                      )}
                    </div>
                    {error && (
                      <div className="alert alert-danger p-2">{error}</div>
                    )}
                    <div className="form-login authentication-check">
                      <div className="row">
                        <div className="col-6">
                          <div className="custom-control custom-checkbox">
                            <label className="checkboxs ps-4 mb-0 pb-0 line-height-1">
                              <input type="checkbox" />
                              <span className="checkmarks" />
                              Remember me
                            </label>
                          </div>
                        </div>
                        <div className="col-6 text-end">
                          <Link
                            className="forgot-link"
                            to={route.forgotPasswordTwo}
                          >
                            Forgot Password?
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className="form-login">
                      <button
                        className="btn btn-login w-100"
                        disabled={isLoading}
                      >
                        {isLoading ? "Signing In..." : "Sign In"}
                      </button>
                    </div>
                    <div className="form-sociallink">
                      <div className="my-4 d-flex justify-content-center align-items-center copyright-text">
                        <p>
                          Copyright © 2025{" "}
                          <Link
                            to="https://perennialcode.in/"
                            className="hover-a"
                          >
                            {" "}
                            Pereco
                          </Link>
                        </p>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="col-lg-6 p-0">
              <div className="login-img">
                <ImageWithBasePath
                  src="assets/img/authentication/authentication-01.svg"
                  alt="img"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SigninTwo;
